import styled from 'styled-components';

// Components
import { Input } from 'top-component-library';

// Constants
import breakpoints from 'constants/breakpoints';
import { button } from 'constants/style';

export const InputSearch = styled(Input.Search)`
  // Search button
  &&& .ant-btn {
    color: var(--bose-landing-button__text);
  }

  &&& .ant-input-affix-wrapper {
    background: var(--bose-landing-search__background);
  }

  // Search bar input
  &&& .ant-input {
    color: var(--bose-landing-search__text);
    background: var(--bose-landing-search__background);

    ::placeholder {
      color: var(--bose-landing-search__text-placeholder);
    }
  }

  // Input and button wrapper
  .ant-input-wrapper {
    display: flex;
    flex-direction: column;

    @media (min-width: ${breakpoints.md}px) {
      display: table;
    }
  }

  // Input wrapper
  &&& .ant-input-affix-wrapper {
    border-radius: var(--input__border-radius);
    height: auto;
    margin-bottom: 1rem;
    padding: 0.75rem;

    border-color: var(--bose-landing-search__border);

    // Close search icon
    .anticon-close-circle {
      color: var(--bose-landing-search__icon);
    }

    &:focus,
    &:hover,
    &.ant-input-affix-wrapper.ant-input-affix-wrapper-focused {
      border-color: var(--bose-landing-search__border-hover);
    }

    &:focus,
    &.ant-input-affix-wrapper.ant-input-affix-wrapper-focused {
      box-shadow: var(--bose-landing-search__hover-box-shadow);
    }

    @media (min-width: ${breakpoints.md}px) {
      border-radius: var(--input__border-radius) 0 0 var(--input__border-radius);
      font-size: 1.25rem;
      height: ${button.regular}px;
      margin-bottom: 0;
      padding: 0.25rem 0.6875rem; // Original AntD Padding
    }
  }

  // Input icon
  .ant-input-prefix {
    margin-right: 12px;
  }

  // Button wrapper
  &&& .ant-input-group-addon {
    left: 0;
    width: 100%;

    border-radius: var(--button__border-radius);

    @media (min-width: ${breakpoints.md}px) {
      left: -1px;
      width: initial;
    }
  }

  // Button
  &&&& .ant-input-search-button {
    background-color: var(--color-button-landing-page__regular);
    border-color: var(--color-button-landing-page__regular);
    border-radius: var(--button__border-radius);
    height: auto;
    letter-spacing: 1px;
    width: 100%;
    padding: 0.75rem 3rem 0.75rem 3rem;
    color: var(--bose-landing-button__text);

    &:hover {
      background: var(--color-button-landing-page__regular);
      color: var(--bose-landing-button__text);
      opacity: 1;
      filter: brightness(85%);
    }

    @media (min-width: ${breakpoints.md}px) {
      border-radius: 0 var(--button__border-radius) var(--button__border-radius) 0;
      height: ${button.regular}px;
      letter-spacing: 1px;
      padding: 0 25px 0 25px;
    }
  }
`;
